import React from 'react'
import OurVision from './OurVision'
import Projects from './Projects'
import bgImage from '../gbv.jpg'
import Button from '../Component/Button'

function Home(prop) {
  return (
    <div>
        <main className='bg-black overflow-hidden sm:border-blue-400 h-[90vh] lg:h-[40rem] sm:h-[35rem] bg-no-repeat bg-contain md:bg-right bg-bottom overflow-hidden relative text-white flex md:py-10'
            // style={{backgroundImage: `url(${bgImage})`}}
            
            > 

            <div className='w-[90%] max-w-[1280px] sm:flex sm:flex-row sm:items-center mx-auto'>
              <div className='flex md:justify-start justify-center flex-col md:w-85 sm:w-[50%] md:flex-row gap-3'>
                  <div className=' flex flex-col sm:h-[22rem] h-[20rem] justify-center  sm:self-center md:w-[57%] '>
                      <h2 className='text-[1.8rem] md:text-[2.2rem] lg:text-[3rem] lg:leading-[3.4rem] font-bold leading-10 font-poppins mb-4'>Empower, <br/> Eradicate, Educate.</h2>
                      <p className='text-[.8rem] lg:text-[1.2rem] w-[90%] font-mada mb-8 font-medium font-regular'>Raise Your Voice: Fight Gender-Based Violence with <span className='bg-orange-400 px-1'> Love and Kindness,</span> Spreading Empathy Through Community.</p>
                      
                    <Button onclick={prop.onclick} children='Donate' className='w-[7rem]' bgColor='bg-orange-500' bdRad='rounded-[1.2rem]' />
                  </div>
                </div>
                <div className='absolute lg:h-[40rem] lg:max-h-[40rem] sm:h-[35rem] sm:max-h-[35rem] h-[17.6rem] sm:w-[50%] max-h-[18rem] bottom-0 w-full right-0'>
                  <img src={bgImage} alt='bgimage' className='lg:h-[40rem] w-full h-[17.6rem] sm:h-[35rem] cover'/> 
                </div>
            </div>
           
              
        </main>
        
            <OurVision onclick={prop.onclick} />
            <Projects/>
        
       

    </div>
  )
}

export default Home